import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';
import { GlobalComponent } from 'src/app/global/global.component';
import { GetListBasetype } from './employee-notes.model';

@Injectable({
  providedIn: 'root'
})

export class EmployeeNotesTypeService extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
    super();
  }

  public execute(ATState: GetListBasetype): void {
    this.gettype(ATState).subscribe(x => super.next(x));
  }

  gettype(ATState?: GetListBasetype): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/NoteType/GetNoteType?", ATState)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count']
          }
      ))

  }
}